module.exports = __webpack_public_path__ + "static/shoe-layers-3-151fe713b77cbc0b978ab47c5f3b0600.png";